import Profile from '../CRUDUtils/ProfilePage'
import { Link } from 'react-router-dom';

export default function ProfilePage() {
  return (
    <div className='container-wrapper'>
      <Profile
        readEndpoint="/read/users?profile_tf=true"
        updateEndpoint="/update/users?profile_tf=true"
        smsReadEndpoint="/read/smsConsent"
        smsUpdateEndpoint="/update/smsConsent"
      />
    </div>
  );
}